module.exports = __webpack_public_path__ + "img/T6-B-xh_21.9589508b.png";